export const SET_DARK_MODE = "darkMode/SET_DARK_MODE";
